// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'

$(document).ready(function() {
  // menu
  $('.navbar-toggle').on('click', function(e) {
    $('.mobile_menu').toggleClass('opened');
  });
  $('.toggle_menu').on('click', function(e) {
    $('.mobile_menu').toggleClass('opened');
  });
  // search form
  $('.search_close').on('click', function(e){
    e.preventDefault();
  	$('.search_form').fadeOut().removeClass('opened');
  });
  $('.search_trigger').on('click', function(e){
    e.preventDefault();
  	$('.search_form').fadeIn().addClass('opened');
  });
  // lingue
  $('.lang_menu').on('click', function() {
    $(this).find('.sub_menu').slideToggle();
  });

  // banner slider
  $('.home_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: true,
    touchMove: true,
    arrows: false,
    dots: true,
    autoplay: true,
    cssEase: 'linear'
  });

  // back to top
  if ($(window).scrollTop() > 50) {
    $('body').addClass('scrolled');
  } else {
    $('body').removeClass('scrolled');
  }
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 50) {
      $('body').addClass('scrolled');
      $('.sticky_info').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
      $('.sticky_info').removeClass('scrolled');
    }
  });

  // vantaggi slider
  $('.slider_vantaggi').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: true,
    touchMove: true,
    arrows: false,
    dots: true,
    autoplay: false
  });

  // applicazione slider
  $('.applicazione_slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          arrows: false
        }
      },
      {
        breakpoint: 660,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });

  $('.case_history_slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000
  });

  // singolo prodotto slider
  $('.gallery_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: true,
    touchMove: true,
    arrows: false,
    dots: true,
    autoplay: true,
    cssEase: 'linear'
  });

  // FAQ accordion
  $('.accordion-header').on('click', function() {
    $(this).toggleClass('opened');
  });

  // modal voce di voce_di_capitolato
  $('.copy').on('click', function(e) {
    e.preventDefault();
    $('#voce_di_capitolato').toggleClass('active');
    $('body').toggleClass('modal_opened');
  });
  $('.close').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.modal').removeClass('active');
    $('body').removeClass('modal_opened');
  });
  $('.modal-overlay').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.modal').removeClass('active');
    $('body').removeClass('modal_opened');
  });
  $('.copy_text').on('click', function (e) {
    e.preventDefault();
    var r = document.createRange();
    var w = document.getElementById("testo_copia");
    r.selectNodeContents(w);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(r);
    document.execCommand("copy");
  });

  $('.sottocategoria').on('click', function(e) {
    e.preventDefault();
    $('#tab_sottocategoria_chiusini > li').removeClass('active');
    $(this).closest('li').addClass('active');
    var classe = $(this).attr('id');
    $('.lista_chiusini > .col').fadeOut();
    $('.' + classe).fadeIn();
  });

  $('#loader').fadeOut();
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js